const preSurveyQuestionsImagine = [
  {
    question: "What is your age range?",
    answers: [
      {
        index: "0",
        content: "Under 18 years old",
      },
      {
        index: "1",
        content: "18-29 years old",
      },
      {
        index: "2",
        content: "30-50 years old",
      },
      {
        index: "3",
        content: "50+ years old",
      },
    ],
    type: "singleChoice",
  },
  {
    question: "What is your gender?",
    answers: [
      {
        index: "0",
        content: "Woman",
      },
      {
        index: "1",
        content: "Non-Binary",
      },
      {
        index: "2",
        content: "Man",
      },
      {
        index: "3",
        content: "Prefer not to answer",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "What demographic do you most closely identify with? (Check all that apply)",
    answers: [
      {
        index: "0",
        content: "Hispanic or Latino",
      },
      {
        index: "1",
        content: "White",
      },
      {
        index: "2",
        content: "Black or African American",
      },
      {
        index: "3",
        content: "Asian",
      },
      {
        index: "4",
        content: "Native Hawaiian or Other Pacific Islander",
      },
      {
        index: "5",
        content: "American Indian or Alaska Native",
      },
    ],
    type: "multiChoice",
  },
  {
    question: "What best describes your year level?",
    answers: [
      {
        index: "0",
        content: "1st year",
      },
      {
        index: "1",
        content: "2nd year",
      },
      {
        index: "2",
        content: "3rd year",
      },
      {
        index: "3",
        content: "4th year",
      },
      {
        index: "4",
        content: "5th year",
      },
      {
        index: "5",
        content: "Graduate Student",
      },
    ],
    type: "singleChoice",
  },
  {
    question: "What is your major?",
    answers: [
      {
        index: "0",
        content: "Computer Science",
      },
      {
        index: "1",
        content: "Software Engineering",
      },
      {
        index: "2",
        content: "Computer Security",
      },
      {
        index: "3",
        content: "Computer Engineering",
      },
      {
        index: "4",
        content: "Other",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “It is difficult to create accessible software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I find planning for accessible software difficult”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I frequently think about accessibility when designing software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I look for accessibility features when I get a new app”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I consider accessibility as a top priority when designing software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
];

export default preSurveyQuestionsImagine;
